module.exports = __webpack_public_path__ + "static/img/VA@3x.4164db3c.jpg";